import React from "react";
import { FaFileInvoiceDollar, FaClock, FaBalanceScale, FaTasks, FaCalculator, FaHandHoldingUsd, FaChartLine, FaCreditCard } from "react-icons/fa";
import "./TallyFieldPage.css";

const PaymentManagement = () => {
  const sections = [
    {
      title: "Receivables & Payables",
      content: "Manage outstanding invoices effortlessly with unique bill references. Keep track of due dates to ensure timely payments.",
      icon: <FaFileInvoiceDollar />,
    },
    {
      title: "Ageing Analysis",
      content: "Identify overdue bills and track outstanding amounts easily. Resolve payments faster to ensure better cash flow.",
      icon: <FaClock />,
    },
    {
      title: "MSME Compliance",
      content: "Effortlessly track compliance with MSME payment rules. Generate automated reports to meet regulatory requirements.",
      icon: <FaBalanceScale />,
    },
    {
      title: "Bill Settlement",
      content: "A flexible and user-friendly system for managing and settling multiple bill payments simultaneously.",
      icon: <FaTasks />,
    },
    {
      title: "Interest Calculations",
      content: "Simplify overdue management with automated interest calculations based on your predefined business rules.",
      icon: <FaCalculator />,
    },
    {
      title: "Cash & Funds Flow",
      content: "Get a clear picture of your financial health. Track payments and receipts to ensure smooth business operations.",
      icon: <FaHandHoldingUsd />,
    },
    {
      title: "Cash Flow Projection",
      content: "Analyze expected inflows and outflows with projection reports, enabling better financial planning.",
      icon: <FaChartLine />,
    },
    {
      title: "Credit Control",
      content: "Set credit limits, track overdue invoices, and send automated reminders to improve payment discipline.",
      icon: <FaCreditCard />,
    },
  ];

  return (
    <div className="tally-field-page">
      <div className="tally-field-container">
        <header className="tally-field-header">
          <span className="subtitle">Core Feature</span>
          <h1>Credit & Collections</h1>
          <p>Optimize your cash flow with advanced receivable and payable management.</p>
        </header>

        <div className="tally-field-grid">
          {sections.map((section, index) => (
            <div className="tally-field-card" key={index}>
              <div className="icon-wrapper">
                {section.icon}
              </div>
              <div className="card-content">
                <h3>{section.title}</h3>
                <p>{section.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PaymentManagement;
